<div class="PGTagPicker">
        <div class="modal-header">
                <h5 class="modal-title">Inserisci le tag</h5>
                <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
        </div>
        <div class="modal-body">
                <app-pg-tags [ngModel]="selectedValue == null ? '' : selectedValue" (ngModelChange)="selectedValue = ($event == '' ? null : $event)"></app-pg-tags>
        </div>
        <div class="modal-footer">
                <button class="btn btn-secondary" (click)="modal.dismiss();">
                        Annulla
                </button>
                <button class="btn btn-primary" (click)="modal.close(selectedValue);">
                        OK
                </button>
        </div>
</div>
